const formats = {
  ORDER_DATE: 'd MMM uuuu, kk:mm',
};

export default formats;
